import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import GridBase from 'shared/components/gif-grid/grid'
import preloadRange from 'shared/components/gif-grid/preload-range'
import fetchOnScroll from 'shared/components/gif-grid/fetch-on-scroll'
import scrollPosition, * as scrolling from 'shared/components/gif-grid/scroll-position-props-proxy'
import { setMaxRequests } from 'shared/util/gif-preload'
import PreloaderIIHOC from 'shared/components/preloader-animation/preloader-animation'
import withPropsOnChange from 'recompose/withPropsOnChange'
import checkForWebP from 'shared/util/check-for-webp'

const MAX_GIF_DETAIL_BYTE_SIZE = 250000, // If a gif original is larger than 2MB load a fixed_height url
    mapGifs = (animatedProp, stillProp, isWebPOkay) => gif => {
        const images = { ...gif.images },
            canUseWebP = isWebPOkay && images.original.webp,
            canUseOriginalStill = images.original_still.size <= MAX_GIF_DETAIL_BYTE_SIZE
        images.animated = images[canUseWebP ? 'original' : animatedProp]
        images.still = images[canUseWebP || canUseOriginalStill ? 'original_still' : stillProp]
        return { ...gif, images }
    },
    // set the animated and still properties on gif.images
    getImages = () =>
        withPropsOnChange(['gifs', 'isWebPOkay'], ({ gifs, isWebPOkay }) => ({
            gifs: gifs.map(mapGifs('downsized_medium', 'fixed_height_still', isWebPOkay)),
        })),
    // set the gif width and height, it's optimal to do it here and not on every render
    getWidthAndHeight = () =>
        withPropsOnChange(['gifs'], ({ gifs }) => ({
            gifHeight: gifs.map(({ images: { still } }) => Math.floor((still.height * 480) / still.width)),
            gifWidth: gifs.map(() => 480),
        })),
    // same as list-channel
    preload = {
        low: -window.innerWidth * 2,
        high: window.innerWidth * 2,
    },
    priority = {
        low: -200,
        high: window.innerWidth + 200,
    }

@checkForWebP
@getImages()
@getWidthAndHeight()
@scrollPosition(window, scrolling.VERTICAL, scrolling.SCROLL_STOP, 0)
@fetchOnScroll(window)
@preloadRange(preload, priority)
@PreloaderIIHOC()
export default class FeedChannel extends GridBase {
    componentWillMount() {
        // Each grid will have to set this if we use SPA navigates
        setMaxRequests(2)
    }
    static defaultProps = {
        queueStillGif: true,
    }
}
